
























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import user from '@/store/modules/user';
import * as api from '@/store/api';
import { CompanySie } from '@/store/models';

@Component({ components: {} })
export default class CompanySelection extends Vue {
  @Prop({ default: true }) readonly useSie!: boolean;
  @Prop({ default: true }) readonly useLatest!: boolean;
  @Prop({ default: true }) readonly useBranch!: boolean;
  @Prop({ default: true }) readonly placeholderShown!: boolean;
  @Prop({ default: null }) readonly company!: any;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: false }) readonly disabledSource!: boolean;
  @Prop({ default: false }) readonly locked!: boolean;
  @Prop({ default: 0 }) readonly sheetLimit!: number;
  @Prop({ default: true }) readonly companyClearable!: boolean;
  selectedData: any = {};

  sies: CompanySie[] | undefined = [];
  sni: any | null = null; // TODO: Move to store

  selectedCompany: any | null = this.company;
  selectedSource: any | null = null;
  selectedBranch: any | null = null;

  async mounted() {
    this.sni = await api.getSNI();
  }

  @Watch('company', { immediate: true, deep: true })
  async companyChanged() {
    if (this.company !== this.selectedCompany) {
      // console.log('EXT COMPANY CHANGED', this.company);
      this.selectedCompany = this.company;
    }
  }

  @Watch('selectedCompany', { immediate: true, deep: true })
  async selectedCompanyChanged() {
    // console.log('INT COMPANY CHANGED', this.selectedCompany);
    if (!this.selectedCompany || !this.selectedCompany.value) {
      this.sies = [];
      this.selectedSource = null;
      this.selectedBranch = null;
    } else {
      this.sies = await api.getSies(user.version, this.selectedCompany.value);
      this.selectedSource = this.getSie(this.selectedCompany.SieAggVersion);
      if (this.useBranch) {
        this.selectedBranch = this.getBranch(
          this.selectedCompany.Branch.substring(0, 3),
        );
      }
    }

    // console.log('EMIT', this.selectedCompany);
    this.$emit('company', this.selectedCompany);
  }

  @Watch('selectedSource')
  selectedSourceChanged() {
    this.$emit('source', this.selectedSource);
  }

  @Watch('selectedBranch')
  selectedBranchChanged() {
    this.$emit('branch', this.selectedBranch);
  }

  @Watch('useBranch')
  suseBranchChanged() {
    if (this.useBranch) {
        this.selectedBranch = this.getBranch(
          this.selectedCompany.Branch.substring(0, 3),
        );
      }
  }

  getSie(id: any): any {
    for (const sie of this.sources) {
      if (sie.id === id) {
        return sie;
      }
    }
    return this.sources[0];
  }

  getBranch(id: string): any {
    console.log('GET BRANCH', id);
    for (const b of this.branches) {
      if (b.id === id) {
        return b;
      }
    }
    return {
      id: '',
      label: '',
      text: '',
    };
  }

  get sources() {
    let res: any = [];
    const v: any = Vue;
    if (this.useSie && this.sies) {
      if (this.selectedCompany && this.selectedCompany.value && !this.selectedCompany.value.startsWith('55')) {
        res = this.sies.map((sie) => {
          return {
            id: sie.AggVersion,
            label: `SIE ${sie.PeriodEnd.substring(
              0,
              7,
            )}`,
            source: `SIE ${sie.PeriodEnd.substring(0, 7)}`,
          };
        });
        res = res.filter((sie: any, index: number, self: any) =>
          index === self.findIndex((t: any) => t.label === sie.label),
        );
        res.sort((a: any, b: any) => {
          return ('' + b.label).localeCompare(a.label);
        });
      } else {
        res = this.sies.map((sie) => {
          return {
            id: sie.AggVersion,
            label: `SIE (${sie.PeriodEnd.substring(
              0,
              7,
            )}, importerad ${v.options.filters.TS2(sie.Created)})`,
            source: `SIE ${sie.PeriodEnd.substring(0, 7)}`,
          };
        });
      }
    }
    if (this.useLatest && this.selectedCompany && this.selectedCompany.dateTo) {
      const year = this.selectedCompany.dateTo.substring(0, 7);
      res.unshift({
        id: 0,
        label: 'Senaste bokslutet (' + year + ')',
        source: 'Bokslut ' + year,
      });
    }
    return res;
  }

  get branches() {
    if (!this.sni) {
      return [];
    }
    const items: any[] = this.sni.items;
    return items.map((sni) => ({
      id: sni.id,
      label: sni.id + ' ' + sni.title,
      text: sni.title,
    }));
  }

  get companies() {
    const res: any = [];
    if (!user.companies) {
      return res;
    }
    for (const c of user.companies) {
      let sheetCount = c.SheetCount;
      if (c.HasSie) {
        sheetCount++;
      }
      if (sheetCount < this.sheetLimit) {
        continue;
      }
      if ((this.useLatest && c.DateTo) || (this.useSie && c.HasSie)) {
        res.push({
          value: c.OrgNr,
          label: c.Name,
          Branch: c.Bransch,
          BranchText: c.BranschText,
          dateTo: c.DateTo,
        });
      }
    }
    res.sort((a: any, b: any) => {
      return ('' + a.label).localeCompare(b.label);
    });
    return res;
  }
}
